export const APP_CONFIG = {
  debug: import.meta.env.DEV,
  baseWidth: 480,
  baseHeight: 270,
  introDesktopVh: 500,
  introMobileVh: 350,
} as const;

export const GAMEPLAY_CONFIG = {
  player: {
    maxLives: 3,
    initialLives: 3,
    maxSpeed: 145,
    acceleration: 720,
    drag: 900,
    invulnerabilityMs: 1250,
  },
  weapon: {
    initialAmmo: 12,
    maxAmmo: 20,
    shotCost: 1,
    fireCooldownMs: 220,
    emptySoundCooldownMs: 650,
    lowAmmoThreshold: 3,
  },
  bullet: { speed: 320, maxActive: 18 },
  asteroid: {
    maxActiveMin: 4,
    maxActiveMax: 11,
    spawnIntervalStartMs: 1450,
    spawnIntervalEndMs: 520,
    reactionTimeStartSec: 0.85,
    reactionTimeEndSec: 0.55,
  },
  score: { pass: 1, destroy: 2 },
  powerUps: {
    firstSpawnDelayMs: { min: 15_000, max: 25_000 },
    intervalMs: { min: 18_000, max: 35_000 },
    maximumActive: 1,
    safeObstacleDistance: 155,
    ammo: { value: 6, baseWeight: 0.78, pityThresholdMs: 40_000 },
    life: { value: 1, baseWeight: 0.22, fullLivesScoreCompensation: 3 },
  },
} as const;
